import { getReferenceDataById } from 'src/app/shared/functions/get-reference-data-by-id';
import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';
import { ParentGuardianDetailsResponse } from '../../verification-guardian-parent-child/models/parent-guardian-details-response.model';

export class StudentDetails {
  lastName: string;
  middleName: string;
  firstName: string;
  gender: IReferenceData;
  dob: Date;
  homeBorough: IReferenceData;
  streetName: string;
  streetNumber: string;
  houseNumber: string;
  city: string;
  state: IReferenceData | number;
  zip: number | string;
  guardianRelationship: IReferenceData;
  guardianFirstName: string;
  guardianLastName: string;
  schoolDistrict: IReferenceData;
  homeDistrict: IReferenceData;
  apartmentNumber: string;
  studentSk: string;

  constructor(data?: ParentGuardianDetailsResponse, referenceData?: Record<string, IReferenceData[]>) {
    if (data) {
      this.lastName = data.childLname;
      this.middleName = data.childNname;
      this.firstName = data.childFname;
      // nothing for gender
      this.gender = getReferenceDataById(data?.childGender, referenceData.sex);
      this.dob = data.childDob !== null ? new Date(data.childDob) : null;
      this.homeBorough = data?.borough?.id ? data.borough : getReferenceDataById(data?.borough as unknown as number, referenceData.borough);
      this.streetName = data.streetName;
      this.streetNumber = data.streetNumber;
      this.apartmentNumber = data.apartmentNumber;
      this.city = data.city;
      this.state = data.state;
      this.zip = data.zip;
      this.guardianRelationship = getReferenceDataById(
        data.relationToChild,
        referenceData.relationship
      );
      this.guardianFirstName = data.parentFname;
      this.guardianLastName = data.parentLname;
      this.schoolDistrict = data.homeDistrict;
      this.homeDistrict = data.homeDistrict;
      this.studentSk = data?.studentSk;
    }
  }
}
